import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || "").filter(Boolean).join(" ");
  return e?.message || "Une erreur est survenue";
}

/* Téléversement découpé : au-delà de 8 Mo, le fichier part en chunks de 8 Mo
   (la limite proxy production est ~100 Mo par requête). Même contrat que POST /upload. */
const UPLOAD_CHUNK = 8 * 1024 * 1024;

export async function uploadFile(file, fields = {}) {
  if (file.size <= UPLOAD_CHUNK && fields.dest !== "drive") {
    const fd = new FormData();
    fd.append("file", file);
    Object.entries(fields).forEach(([k, v]) => v != null && fd.append(k, v));
    const { data } = await api.post("/upload", fd);
    return data;
  }
  const { data: init } = await api.post("/upload/init");
  const total = Math.ceil(file.size / UPLOAD_CHUNK);
  for (let i = 0; i < total; i++) {
    await api.put(`/upload/chunk/${init.upload_id}?index=${i}`,
      file.slice(i * UPLOAD_CHUNK, (i + 1) * UPLOAD_CHUNK),
      { headers: { "Content-Type": "application/octet-stream" } });
  }
  const fd = new FormData();
  fd.append("filename", file.name);
  Object.entries(fields).forEach(([k, v]) => v != null && fd.append(k, v));
  const { data } = await api.post(`/upload/complete/${init.upload_id}`, fd);
  return data;
}

export default api;
